import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimoniosSection() {
  const testimonios = [{
    name: 'Carlos M.',
    location: 'Madrid, España',
    quote: 'Llevaba años estancado en mis ingresos. A los 14 días de escuchar el audio y aplicar el manual, cerré el contrato más grande de mi vida. Parece magia, pero es frecuencia.',
    rating: 5
  }, {
    name: 'Laura V.',
    location: 'Bogotá, Colombia',
    quote: 'Mi relación con el dinero era de puro estrés. El Código 888 reprogramó mi ansiedad. Ahora el dinero fluye hacia mí de formas inesperadas. Totalmente recomendado.',
    rating: 5
  }, {
    name: 'Alejandro R.',
    location: 'Miami, USA',
    quote: "Era escéptico sobre la 'programación cuántica'. Pero los resultados hablan por sí solos. Multipliqué mis fuentes de ingresos en menos de un mes. Es una inversión ridícula para lo que obtienes.",
    rating: 5
  }];
  return <section id="testimonios" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-dark relative border-t border-white/5" data-id="element-152">
      <div className="max-w-[1200px] mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" style={{
        opacity: 1
      }} data-id="element-154">
          <h2 className="font-serif text-3xl md:text-5xl font-black mb-6" data-id="element-155">
            RESULTADOS <span className="text-gold" data-id="element-156">CUÁNTICOS</span>
          </h2>
          <p className="text-lg opacity-80 max-w-2xl mx-auto" data-id="element-157">
            Personas reales experimentando transformaciones financieras reales
            al sintonizar con la frecuencia correcta.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-158">
          {testimonios.map((testimonio, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white/5 border border-gold/10 p-8 rounded-xl relative" style={{
          opacity: 1
        }} data-id="element-159">
              <div className="flex gap-1 mb-6" data-id="element-160">
                {[...Array(testimonio.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-161" />)}
              </div>
              <p className="opacity-90 leading-relaxed mb-8 italic" data-id="element-162">
                "{testimonio.quote}"
              </p>
              <div className="flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-163">
                <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center font-bold text-gold" data-id="element-164">
                  {testimonio.name.charAt(0)}
                </div>
                <div data-id="element-165">
                  <h4 className="font-bold" data-id="element-166">{testimonio.name}</h4>
                  <p className="text-xs opacity-50 uppercase tracking-wider" data-id="element-167">
                    {testimonio.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}